import Div from 'src/components/atomic/atom/Div'
import Button from 'src/components/atomic/atom/Button'
import { COLOR } from 'src/constants/colors'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import { LocationDataPropsType } from 'src/views/Service/Location'
import LocationPlaySoundList from 'src/components/atomic/organisms/views/Location/LocationPlaySoundList'
import { RootState } from 'src/store/store'
import { ColorHandler } from 'src/utils/style.utils'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
const LocationPlayBtn = (props: { data: LocationDataPropsType }) => {
  // wifilist, sound play
  const { modalCall, onSoundBtnClick } = props.data
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()
  const { soundPlayStatus, soundListFlag } = useAppSelector(
    (state: RootState) => state.LocationPage,
  )
  const { Connection } = useAppSelector((state: RootState) => state.connection)
  return (
    <>
      <Div
        display={'flex'}
        $justify_content={'space-between'}
        $flex_wrap={setMediaStyle('', 'wrap', 'wrap')}
        $gap={setMediaStyle('', '12px', '12px')}
      >
        <Button
          option={'location_wifi'}
          $margin={'0'}
          $border={`1px solid ${ColorHandler(Connection, 'brand_black10')}`}
          disabled={!Connection}
          onClick={() => modalCall('wifiList')}
          className={'location_detectwifi_click'}
        >
          <Svg name={Connection ? 'wifi_active' : 'wifi'} width={'18px'} height={'18px'} />
          <Span
            width={'auto'}
            option={'tiny_bold'}
            color={ColorHandler(Connection, 'brand_black30')}
          >
            {t('BUTTON.LOCATE_DETECT_WIFI', { defaultValue: 'Detect Wi-Fi' })}
          </Span>
          <Svg name={'arrow'} $margin={'3px 0'} color={ColorHandler(Connection, 'brand_black30')} />
        </Button>
        <Div
          display={'block'}
          width={setMediaStyle('auto', '100%', '100%')}
          style={{ position: 'relative' }}
        >
          <Button
            option={'location_play_sound'}
            $margin={'0'}
            $bgColor={soundPlayStatus ? COLOR.red80 : Connection ? COLOR.brand : COLOR.black10}
            disabled={!Connection}
            $playStatus={soundPlayStatus.toString()}
            onClick={onSoundBtnClick}
            style={{ zIndex: 2, position: 'relative' }}
          >
            <Svg name={'location_sound'} color={ColorHandler(Connection, 'white_black30')} />
            <Span
              width={'auto'}
              option={'tiny_bold'}
              color={ColorHandler(Connection, 'white_black30')}
            >
              {soundPlayStatus
                ? 'STOP'
                : t('BUTTON.LOCATE_PLAY_SOUND', { defaultValue: 'Play Sound' })}
            </Span>
            {soundPlayStatus ? (
              <Div $bgColor={COLOR.white} height={'12px'} width={'12px'} />
            ) : (
              <Svg
                color={ColorHandler(Connection, 'white_black30')}
                name={'arrow'}
                style={{
                  transform: soundListFlag ? `rotate(-90deg)` : `rotate(90deg)`,
                  transition: 'all 0.2s',
                }}
              />
            )}
          </Button>
          <LocationPlaySoundList data={props.data} />
        </Div>
      </Div>
    </>
  )
}
export default LocationPlayBtn
